import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: number;
  title: string;
  summary: string;
  imageUrl: string;
  date: string;
  readTime: string;
}

export default function ArticleCard({ id, title, summary, imageUrl, date, readTime }: ArticleCardProps) {
  return (
    <article className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden group transition-all hover:border-primary-200/60">
      <Link to={`/article/${id}`} className="block cursor-pointer">
        <div className="relative h-48 overflow-hidden">
          <img
            src={imageUrl}
            alt={title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
        </div>
        <div className="p-5">
          <div className="flex items-center gap-3 text-xs text-foreground-400 mb-3">
            <span>{date}</span>
            <span>·</span>
            <span>{readTime}</span>
          </div>
          <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {title}
          </h3>
          <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
            {summary}
          </p>
          <div className="mt-4 flex items-center text-sm text-primary-500 font-medium">
            <span>阅读全文</span>
            <i className="ri-arrow-right-line ml-1 text-xs group-hover:translate-x-1 transition-transform"></i>
          </div>
        </div>
      </Link>
    </article>
  );
}